import React from "react";
import { ScenarioOption } from "../services/scenarioAdminService";

interface AllowedScenariosMultiselectProps {
  options: ScenarioOption[];
  selected: string[];
  onChange: (ids: string[]) => void;
}

const AllowedScenariosMultiselect: React.FC<AllowedScenariosMultiselectProps> = ({
  options,
  selected,
  onChange,
}) => {
  const toggle = (id: string) =>
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);

  return (
    <div className="border border-outline-variant/30 rounded-md p-2 flex flex-wrap gap-2">
      {options.length === 0 && (
        <span className="text-slate-400 text-xs">No scenarios available.</span>
      )}
      {options.map((o) => {
        const on = selected.includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => toggle(o.id)}
            className={
              on
                ? "px-3 py-1 rounded-full text-xs bg-primary text-white"
                : "px-3 py-1 rounded-full text-xs bg-surface-container text-slate-300"
            }
          >
            {o.title} {on ? "✓" : "+"}
          </button>
        );
      })}
    </div>
  );
};

export default AllowedScenariosMultiselect;
